/* eslint @typescript-eslint/no-var-requires: "off" */

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/ja";

dayjs.locale("ja");
dayjs.extend(utc);

export default function setupDayjs(app) {
  app.config.globalProperties.$dayjs = dayjs;
}
